
	import {
		Request
	} from '@/api/request';
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch,
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
	import {
		getCouponList
	} from "@/api/http";

	const columnList: Array < any > = [{
			prop: "title",
			label: "订单号",
			width: 100,
		},
		{
			prop: "type_text",
			label: "用户ID",
			width: 160,
		},
		{
			prop: "term_text",
			label: "评论星级",
			width: 160,
		},
		{
			prop: "grant_text",
			label: "评论日期",
			width: 100,
		},
	];
	
	const distributionRules: any = {
		user_id: [
			{required: true, message: '请输入用户名称', trigger: 'blur'},
		],
		coupon_id: [
			{required: true, message: '请选择优惠卷', trigger: 'change'},
		],
		
	}

	export default defineComponent({
		name: "evaluation",
		setup() {
			const setTitle: any = inject("setTitle");
			setTitle(["评论管理"]);
			let pageSize = ref(10),
				currentPage = ref(1),
				orderStatus = ref(0),
				loading = ref(false),
                dialog_index = ref(0),
				total = ref(0),
				headClass = inject("headClass"),
				project = ref([]),
				Router = useRouter(),
				tableData = ref([] as Array <any> ),
				selectGroup = reactive({
					status: "",
					date: "",
					search: "",
				}),
				screenParameter = ref({
					page: currentPage.value,
					limit: pageSize.value,
					search: '',
                    time: null
				} as any),
                dialog_model = ref(''),
                reply_details = ref(''),
				is_dialog = ref(false),
				distributionForm:any =  ref({
					user_id: '',
					coupon_id: '',
					member: '',
				}),
				distributionFormRef = ref(null),
				distributionForm_isload = ref(false),
				distributionList = ref([] as Array <any> )

			let getTableData = () => {
					loading.value = true;
					Request.axiosInstance({
						url: 'adminapi/Evaluation/list',
						data: screenParameter
					}).then((res: any) => {    
						tableData.value = res?.content?.list || [];
						project.value = res?.content?.project || [];
						loading.value = false;
						total.value = res?.content?.total || 0;
					});
				},
				handleSizeChange = (size: number): void => {
					pageSize.value = size;
					getTableData();
				},
				handleCurrentChange = (page: number): void => {
					currentPage.value = page;
					getTableData();
				},
				columnChange = (id: number, type: boolean) => {
					Request.axiosInstance({
						url: 'adminapi/Coupon/upState',
						data: {
							coupon_id: id,
							status: type
						}
					}).then((res: any) => {
						console.log(res)
					})
				},
				screenChange = (e: string | Array < any > , key: any): void => {
					if (!e) {
						delete screenParameter[key];
					} else {
						if (key == "start_date") {
							let date = [];
							screenParameter["start_date"] = new Date(
								e[0]
							).getTime();
							screenParameter["end_date"] = new Date(e[1]).getTime();
						} else {
							screenParameter["search"] = e as string;
						}
					}
					getTableData();
				},
				_distribution = () => {
					is_dialog.value = true
					distributionForm_isload.value = true
					getCouponList({status: '1'}).then((res: any) => {
						var list = res?.content?.list || []
						distributionList.value = list
						distributionForm_isload.value = false
					});
					
				},

				//adminapi/VipCard/upState
				_upState = (id: number) => {


					
				},
				_distributionformSubmit = () => {
					
                    Request.axiosInstance({
                        url: 'adminapi/Evaluation/reply',
                        data: {evaluation_id: tableData.value[dialog_index.value].id , reply_details: reply_details.value}
                    }).then(() => {
                        getTableData()
                        dialog_model.value = ''
                    })

				},
                _dialog = (i: number) => {
                    dialog_index.value = i
                    dialog_model.value = 'manage'
                },
				_option = (url: string , data: any) => {
					Router.push({
						path: url,
						query: data
					})
				
				}

			onMounted(() => {
				getTableData();
			});

			watch(orderStatus, (newValue, oldValue) => {
				//screenParameter.status = orderStatusNav[newValue].id;
				getTableData();
			});

			return {
				selectGroup,
				pageSize,
				currentPage,
				orderStatus,
				columnList,
				loading,
				tableData,
				project,
				handleSizeChange,
				handleCurrentChange,
				total,
				columnChange,
				headClass,
				screenChange,
				is_dialog,
				_distribution,
				_distributionformSubmit,
				distributionForm,
				distributionList,
				distributionForm_isload,
				distributionFormRef,
				distributionRules,
				_option,
                screenParameter,
                dialog_model,
                dialog_index,
                _dialog,
                reply_details
			};
		},
	});
